import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "ic-vector_f847c9da3b350f2058b5f53886414735",
  "use": "ic-vector_f847c9da3b350f2058b5f53886414735-usage",
  "viewBox": "0 0 18 14",
  "content": "<symbol viewBox=\"0 0 18 14\" xmlns=\"http://www.w3.org/2000/svg\" id=\"ic-vector_f847c9da3b350f2058b5f53886414735\">\n<path d=\"M6.00039 11.2001L1.80039 7.0001L0.400391 8.4001L6.00039 14.0001L18.0004 2.0001L16.6004 0.600098L6.00039 11.2001Z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default "#" + symbol.id